import React, { useCallback } from 'react';
import { TabsWrapper } from 'framework/ui/TabsWrapper';
import RelatedInvoicesByVendor from './RelatedInvoicesByVendor';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Box } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useLocation, useNavigate } from 'react-router-dom';
import { useVendorId, useVendorsUrl } from 'domain/finance/vendors/routes';
import VendorAgreements from './VendorAgreements';
import VendorTimeline from './Timeline/VendorTimeline';
import VendorDocuments from './vendorDocuments/VendorDocuments';
import { useAuthorization } from 'framework/authorization';
import { READ_VENDOR_DOCUMENTS } from './vendorDocuments/useVendorDocumentsService';

const TAB_PATHS: Record<string, number> = {
  '/timeline': 0,
  '/documents': 1,
  '/agreements': 2,
  '/related-invoices': 3,
};

const VendorTabsSection = () => {
  const id = useVendorId();
  const { isGranted } = useAuthorization();
  const { getTimelineUrl, getRelatedInvoicesUrl, getVendorAgreementsUrl, getDocumentsVendorUrl } = useVendorsUrl();
  const location = useLocation();
  const navigate = useNavigate();
  const defaultTab = TAB_PATHS[location.pathname] ?? 0;

  const onChangeTabCallback = useCallback(
    (route: string) => {
      navigate(route);
    },
    [navigate],
  );

  return (
    <TabsWrapper
      defaultTab={defaultTab}
      sxContentProps={{}}
      tabs={[
        {
          label: (
            <Box display="flex" alignItems="center">
              <HistoryIcon sx={{ mr: '3px', fontSize: '15px' }} />
              <span>Timeline</span>
            </Box>
          ),
          onClick: () => onChangeTabCallback(getTimelineUrl(id)),
          content: <VendorTimeline />,
        },
        {
          label: (
            <Box
              display="flex"
              alignItems="center"
              sx={{
                '> .fa': {
                  mr: '3px',
                  fontSize: '13px',
                },
              }}
            >
              <i className="fa fa-folder-open-o" aria-hidden />
              <span>Documents</span>
            </Box>
          ),
          isVisible: isGranted(READ_VENDOR_DOCUMENTS),
          onClick: () => onChangeTabCallback(getDocumentsVendorUrl(id)),
          content: <VendorDocuments />,
        },
        {
          label: (
            <Box display="flex" alignItems="center">
              <HandshakeIcon sx={{ mr: '3px', fontSize: '15px' }} />
              <span>Vendor agreements</span>
            </Box>
          ),
          onClick: () => onChangeTabCallback(getVendorAgreementsUrl(id)),
          content: <VendorAgreements />,
        },
        {
          label: (
            <Box display="flex" alignItems="center">
              <ReceiptIcon sx={{ mr: '3px', fontSize: '15px' }} />
              <span>Related invoices</span>
            </Box>
          ),
          onClick: () => onChangeTabCallback(getRelatedInvoicesUrl(id)),
          content: <RelatedInvoicesByVendor />,
        },
      ]}
    />
  );
};

export default VendorTabsSection;
